export default () => {
	const headerBasketIcon = document.querySelector(".header-account__basket");
	const basket = document.querySelector(".basket");

	headerBasketIcon.addEventListener("click", () => {
		basket.classList.toggle("active");
	});

    document.addEventListener("click", toggleDropdown);

    function toggleDropdown(event) { 
        if (basket.contains(event.target) || headerBasketIcon.contains(event.target)) return;
        basket.classList.remove("active");
    }
};
